module.exports = __webpack_public_path__ + "static/img/pic_gongchangshebei.95d7482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_gongchangshebei.png
// module id = /erH
// module chunks = 1